import React, { useMemo, useState, useEffect } from "react";

import { Select } from "antd";
import { setWidgetInSheetParams } from "appRedux/actions/Actions";
import { setChatSettings } from "../../../../appRedux/actions/ChatSettings";
import { useDispatch, useSelector } from "react-redux";
import { useIntl } from "react-intl";

import IntlMessages from "@util/IntlMessages";
import { showName } from "@util/Scripts";

import { Message, Switch, Button, Spin, Input } from "../../../BP2Components";
import { Icon_Plus } from "../../../BP2Components/Icons/icons";
import "../ChatSettings/ChatStyle.less";

//NOTE:

// in chat settings we need to overwrite bords object, becouse translations we use here are in boards object
// and not in actuall widget. so we cannot just overwrite widget settings

const AdvertisementListPrivateChatSettings = (props) => {
   const [newBoard, setNewBoard] = useState({ ...props?.data });
   const [usersToAdd, setUsersToAdd] = useState(props?.value?.chatUsersColumnTechNames);

   const [chatActionSettings, setChatActionSettings] = useState({
      chatPrivateButtonTitle: props?.value?.chatPrivateButtonTitle,
      showPrivateChatButton: props?.value?.showPrivateChatButton,
      privateChatTitle: props?.value?.privateChatTitle,
      privateChatSubtitle: props?.value?.privateChatSubtitle,
      usersTechName: props?.value?.chatUsersColumnTechNames
   });

   const selectOptions = [];

   const { allLanguages } = useSelector(({ settings }) => settings);

   const dispatch = useDispatch();
   const intl = useIntl();

   useEffect(() => {
      const columnsToDisplay = chatActionSettings?.usersTechName?.map((element, index) => ({
         index,
         columnTechName: element?.columnTechName,
         type: element?.type
      }));
      setUsersToAdd(columnsToDisplay ? columnsToDisplay : []);
   }, []);

   useMemo(() => {
      allLanguages.forEach((item) => {
         setChatActionSettings((prevState) => {
            return {
               ...prevState,
               [`name${item.language}`]: props?.data?.translations?.find(
                  (item) =>
                     Object.values(item).find(
                        (item) => item == props?.value?.chatPrivateButtonTitle
                     ) == props?.value?.chatPrivateButtonTitle
               )?.values?.[`${item.language}`]
            };
         });
      });
   }, []);

   const saveChatSettings = async () => {
      const changedSettings = { ...props?.data };
      const requiredWidget = props?.value;
      requiredWidget.showPrivateChatButton = chatActionSettings?.showPrivateChatButton;
      requiredWidget.privateChatTitle = chatActionSettings?.privateChatTitle;
      requiredWidget.privateChatSubtitle = chatActionSettings?.privateChatSubtitle;
      requiredWidget.chatUsersColumnTechNames = usersToAdd;

      const findTranslation = newBoard.translations.find(
         (item) => item.key == props?.value?.chatPrivateButtonTitle
      );

      if (findTranslation) {
         findTranslation.values = allLanguages.reduce((target, key) => {
            target[key.language] = Object.entries(chatActionSettings).find(
               (item) => item[0] == `name${key.language}`
            )[1];
            return target;
         }, {});
      } else {
         newBoard.translations.push({
            category: null,
            key: chatActionSettings?.chatPrivateButtonTitle,
            values: allLanguages.reduce((target, key) => {
               target[key.language] = Object.entries(chatActionSettings).find(
                  (item) => item[0] == `name${key.language}`
               )[1];
               return target;
            }, {})
         });
      }

      dispatch(setWidgetInSheetParams({ ...chatActionSettings }));
      setNewBoard({ ...changedSettings });
   };

   if (props) {
      props?.columns?.forEach((column, idx) => {
         if (column.title !== undefined) {
            selectOptions.push(
               <Select.Option key={idx} value={column.dataIndex}>
                  {column.title}
               </Select.Option>
            );
         }
      });
   }

   const handleSubmit = (e) => {
      e.preventDefault();
      if (chatActionSettings.showPrivateChatButton) {
         if (usersToAdd[0]?.columnTechName !== undefined && usersToAdd[0]?.type === "owner") {
            saveChatSettings(chatActionSettings);
            dispatch(setChatSettings(chatActionSettings));
            Message.success(intl.formatMessage({ id: "global.saved" }));
         } else {
            Message.error(intl.formatMessage({ id: "chat.requiredPersonAdding" }));
         }
      } else {
         saveChatSettings(chatActionSettings);
         dispatch(setChatSettings(chatActionSettings));
         Message.success(intl.formatMessage({ id: "global.saved" }));
      }
   };

   const handleSwitch = (checked, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: checked });
   };

   const handleChangeInput = (event, name) => {
      setChatActionSettings({ ...chatActionSettings, [name]: event.target.value });
   };

   const handleSelectTitle = (selectedTitle) => {
      setChatActionSettings({ ...chatActionSettings, privateChatTitle: selectedTitle });
   };

   const handleSelectSubTitle = (selectedSubTitle) => {
      setChatActionSettings({ ...chatActionSettings, privateChatSubtitle: selectedSubTitle });
   };

   const handleSelectUsers = (selectedUser, index) => {
      let requiredColumns = [...usersToAdd];
      requiredColumns.find((item) => item?.index == index).columnTechName = selectedUser;
      setUsersToAdd(requiredColumns);
   };

   const addColumn = () => {
      setUsersToAdd([...usersToAdd, { index: usersToAdd?.length, type: "user" }]);
   };

   const deleteColumn = (e) => {
      setUsersToAdd(usersToAdd.filter((value) => value !== e));
   };

   const setUserToOwner = (e) => {
      //finding column to change type to owner
      let userIndex = usersToAdd?.find((value) => value?.index === e?.index)?.index;

      // deleting all type of "owners"
      const deleteAllOwners = usersToAdd.map((elem) =>
         elem.type === "owner" ? { ...elem, type: "user" } : elem
      );

      // setting new owner
      const newOwner = deleteAllOwners.map((elem) =>
         elem.index === userIndex ? { ...elem, type: "owner" } : elem
      );
      setUsersToAdd(newOwner);
   };

   return (
      <>
         <form onSubmit={handleSubmit}>
            <div className="widget-settings">
               <div key="btnSet" className="widget-settings__inner">
                  <label key="showPrivateChatButton" className="widget-settings__inner__label">
                     <IntlMessages id="Show chat button" />:
                     <Switch
                        name="showPrivateChatButton"
                        onChange={(e) => handleSwitch(e, "showPrivateChatButton")}
                        defaultChecked={chatActionSettings?.showPrivateChatButton}
                     />
                  </label>
                  <label className="widget-settings__inner__label">
                     <IntlMessages id="Chat name" />:
                     <Input
                        style={{ width: "400px" }}
                        name="chatTitle"
                        defaultValue={chatActionSettings?.chatPrivateButtonTitle}
                        disabled
                     />
                  </label>
                  {allLanguages ? (
                     allLanguages?.map((item) => (
                        <label
                           key={item.language}
                           className="widget-settings__inner__label"
                           style={{ marginLeft: "60px" }}
                        >
                           <IntlMessages id={`Chat name ${item.language}`} />:
                           <Input
                              style={{ width: "350px" }}
                              type="translation"
                              name={`name${item.language}`}
                              defaultValue={
                                 chatActionSettings[`name${item.language}`]
                                    ? chatActionSettings[`name${item.language}`]
                                    : showName(
                                         `${item.language}`,
                                         chatActionSettings.chatPrivateButtonTitle,
                                         chatActionSettings
                                      )
                              }
                              onChange={(e) => handleChangeInput(e, `name${item.language}`)}
                           />
                        </label>
                     ))
                  ) : (
                     <div className="no-translations">
                        <Input
                           style={{ width: "400px" }}
                           name="chatTitle"
                           defaultValue={intl.formatMessage({
                              id: "no.translations.available"
                           })}
                           disabled
                        />
                     </div>
                  )}

                  <label style={{ marginLeft: "30px" }} className="widget-settings__inner__label">
                     <IntlMessages id="chat.list.settings.title" />:
                     <Select
                        defaultValue={chatActionSettings?.privateChatTitle}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
                  <label className="widget-settings__inner__label" style={{ marginLeft: "8px" }}>
                     <IntlMessages id="settings.subtitleAdvertismentList" />:
                     <Select
                        defaultValue={chatActionSettings?.privateChatSubtitle}
                        style={{ width: "400px" }}
                        onChange={(e) => handleSelectSubTitle(e)}
                     >
                        {selectOptions === undefined ? <Spin /> : selectOptions}
                     </Select>
                  </label>
                  {usersToAdd?.length !== 0 ? (
                     <div style={{ marginLeft: "70px" }} className="item-content-rows-list">
                        <div style={{ width: "601px" }} className="item-content-row-container">
                           <div className="item-content-columns-list">
                              {usersToAdd?.map((column, index) => {
                                 return (
                                    <div
                                       style={{ width: "587px" }}
                                       className="item-content-column-container"
                                    >
                                       <div className="item-content-column-name">
                                          <IntlMessages id="chat.settings.addUser" />
                                       </div>
                                       <Select
                                          style={{ width: "383px" }}
                                          onChange={(e) => handleSelectUsers(e, index)}
                                          defaultValue={
                                             selectOptions.find(
                                                (item) => item.props.value == column.columnTechName
                                             )?.props.children
                                          }
                                       >
                                          {selectOptions === undefined ? (
                                             <Spin />
                                          ) : (
                                             selectOptions.filter(
                                                (item) =>
                                                   item.props.value !=
                                                   usersToAdd?.find(
                                                      (column) =>
                                                         column.columnTechName == item.props.value
                                                   )?.columnTechName
                                             )
                                          )}
                                       </Select>
                                       <div>
                                          <Button
                                             className={
                                                column?.type === "owner" ? "ant-btn-primary" : null
                                             }
                                             onClick={() => setUserToOwner(column)}
                                          >
                                             <IntlMessages id="chat.isOwner" />
                                          </Button>
                                          <Button
                                             onClick={() => {
                                                deleteColumn(column);
                                             }}
                                             buttonType="danger"
                                          >
                                             <i className=" icon icon-trash" />
                                          </Button>
                                       </div>
                                    </div>
                                 );
                              })}
                           </div>
                        </div>
                     </div>
                  ) : null}
                  <Button
                     style={{ marginLeft: "70px", marginBottom: 20 }}
                     onClick={() => addColumn()}
                  >
                     <Icon_Plus />
                     {usersToAdd?.length !== 0 ? "Add Another User" : "Add User"}
                  </Button>
               </div>
               <Button buttonType="primary" htmlType="submit">
                  <IntlMessages id="global.preview" />
               </Button>
            </div>
         </form>
      </>
   );
};
export default AdvertisementListPrivateChatSettings;
